// extracted by mini-css-extract-plugin
export var cancelButton = "_p6-5";
export var content = "_p6-3";
export var createButton = "_p6-6";
export var drawerContainer = "_p6-0";
export var footer = "_p6-2";
export var header = "_p6-1";
export var orderFormColumn = "_p6-4";